module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.3b5d1c6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.eot
// module id = VlGX
// module chunks = 13 14